<template>
  <div>
    <div v-if="!text">
      <div
        v-if="loading"
        id="carregaDados"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando Dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <canvas
        id="myChart35"
        width="180"
        height="70"
      />
      <br>
      <div
        v-if="exibirLegenda"
        id="legendaDistribuicaoCliente"
        class="text-center px-3"
      >
        <v-row
          align="center"
          class="ma-0"
          no-gutters
        >
          <v-col
            md="12"
            offset-md="1"
          >
            <v-row>
              <div
                v-for="status in legenda"
                :key="status.statusExibicao"
              >
                <v-avatar
                  class="mr-1"
                  :color="status.corExibicao"
                  size="12"
                />
                <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Cliente from '../../../../services/clientes'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardDistribuicaoNovosClientes',
    emits: ['updateBtnPrint'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleCliente: {
        color: '#ed934f',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      datasetd: [],
      legenda: [],
      enableGrafico: true,
      text: null,
      montaGrafico: true,
      clientesFaturado: 0,
      clientesTotalAtivos: 0,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      loading: false,
      error: null,
      exibirLegenda: false,
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.dataFinal = ultimoDia
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.MontarGrafico()
      },

      async MontarGrafico () {
        this.loading = true
        this.exibirLegenda = false
        this.legenda = []

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Cliente.showDistribuicaoClientesAnual(this.primeiroDia, this.dataFinal, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            this.legenda = resposta.data.legenda

            const ctx = document.getElementById('myChart35').getContext('2d')

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.datasExibicao,
                datasets: [
                  {
                    label: 'Novos clientes',
                    data: resposta.data.clientesNovos,
                    backgroundColor: '#0088cc',
                    order: 1,
                  },
                  {
                    label: 'Venda inferior a 150 dias',
                    data: resposta.data.clientesAte150,
                    backgroundColor: '#d36156',
                    order: 2,
                  },
                  {
                    label: 'Venda entre 150 a 180 dias',
                    data: resposta.data.clientes150A180,
                    backgroundColor: '#16ae64',
                    order: 3,
                  },
                  {
                    label: 'Venda superior a 180 dias',
                    data: resposta.data.clientesSuperior180,
                    backgroundColor: '#ff9900',
                    order: 4,
                  },
                  {
                    label: 'Clientes sem movimentação',
                    data: resposta.data.clientesSemMovimentacao,
                    backgroundColor: '#BDBDBD',
                    order: 5,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: false,
                    align: 'center',
                    color: function (context) {
                      return 'black'
                    },
                    font: {
                      size: 11,
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      if (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] > 0) {
                        var type = data.datasets[tooltipItem.datasetIndex].label
                        var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]

                        return type + ': ' + valor
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })

            eventEmit.$emit('update-btn-print', true)
          } else if (resposta.data.msg === 'Não há dados disponíveis no período selecionado') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #myChart35 {
      width: 410px !important;
      height: 250px !important;
      margin: 0 0 0 -1rem;
    }

    #legendaDistribuicaoCliente {
      font-size: 10px;
      margin: 1rem 0 1rem 0rem
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart35 {
      width: 434px !important;
      height: 250px !important;
    }

    #legendaDistribuicaoCliente {
      font-size: 10px;
      margin: 1rem 0 1rem 0rem;
    }
  }
</style>

<style lang="sass">
  #legendaDistribuicaoCliente
    font-size: 14px
    margin: 1rem 0 1rem 0rem
  // #myChart33
  //   margin: -1.5rem 0 0 0

  // #porcentagemClienteFaturado
  //   margin: -3.5rem 0 0 0
  //   font-weight: bold

</style>
